import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@hummingbirdtechgroup/wings-ui';
const useStyles = makeStyles(({ componentSizing, spacing, zIndex }) => ({
    navBarRoot: {
        background: 'linear-gradient(to right, #07181f 0%, #113542 100%)',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        overflowX: 'hidden',
        position: 'absolute',
        zIndex: zIndex.leafletMax + 2,
    },
    vertical: {
        flexDirection: 'column',
        width: componentSizing.navBar,
        height: '100%',
    },
    horizontal: {
        height: componentSizing.navBar,
        width: '100%',
    },
}));
function NavBar({ children, className, variant = 'vertical', }) {
    const classes = useStyles();
    return (React.createElement("nav", { className: classNames(className, classes.navBarRoot, classes[variant]) }, children));
}
export default NavBar;
//# sourceMappingURL=NavBar.js.map